module.exports = __webpack_public_path__ + "img/hero-section.bbeb6a9.webp";